import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { NgScrollbar } from 'ngx-scrollbar';
import { TranslateModule } from '@ngx-translate/core';
import { MatIcon } from '@angular/material/icon';
import { MatNavList } from '@angular/material/list';

export interface ListInfo {
  videoUrl: string;
  learnMoreText: string;
  content: string;
  links: {
    label: string;
    url: string;
  }[];
}

@Component({
  selector: 'qa-no-entity-info',
  templateUrl: './no-entity-info.component.html',
  styleUrls: ['./no-entity-info.component.scss'],
  imports: [NgScrollbar, TranslateModule, MatIcon, MatNavList],
})
export class NoEntityInfoComponent implements OnInit {
  @Input() listInfo: ListInfo;
  videoUrl: SafeResourceUrl;

  constructor(private sanitizer: DomSanitizer) {}

  ngOnInit(): void {
    if (this.listInfo && this.listInfo.videoUrl) {
      this.videoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
        this.listInfo.videoUrl
      );
    }
  }
}
